<script setup lang="ts">
import {CalendarEvent} from "@/appointment/components/consumer-appointment-timeline/event-calendar/EventCalendar.vue";

defineProps<{
    event: CalendarEvent
}>();
</script>

<template>
  <div class="border-b border-gray-200 pb-2">
    <span>
      {{ event.time }}
    </span>
    <span class="block text-sm font-medium" :style="{ color: event.color || '#4A90E2' }">
      {{ event.title }}
    </span>
    <span v-if="event.patientName" class="block">Patient : {{ event.patientName }}</span>
    <span v-if="event.operatorName">Opérateur : {{ event.operatorName }}</span>
  </div>
</template>

<style scoped>

</style>
